import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FiltersAthleteGeneralService } from '../../services/filters-athlete-general.service';
import { first, tap, mergeMap } from 'rxjs/operators';

/**
 * A component to do proxy in /photos/:id
 *
 * @export
 * @class ProxyAthleteComponent
 * @implements {OnInit}
 */
@Component({
  selector: 'app-proxy-athlete',
  templateUrl: './proxy-athlete.component.html',
  styleUrls: ['./proxy-athlete.component.scss']
})
export class ProxyAthleteComponent implements OnInit {

  constructor(
    private _router: Router,
    private _route: ActivatedRoute,
    private generalAthleteService: FiltersAthleteGeneralService) {
    generalAthleteService.athleteDetailStore.requestData({ Id: _route.snapshot.params['id'] }, false).pipe(tap(next => {
      const url = _router.createUrlTree(
        [
          "/athlete",
          _route.snapshot.params['id'],
          this.generalAthleteService.getAthleteName(this.generalAthleteService.athleteDetailStore.data[0])
            .replace(/ /g, "-")
            .toLowerCase(),
          'photos'
        ],
        { relativeTo: _route }
      );
       _router.navigateByUrl(url, { skipLocationChange: true });
    })).subscribe();
  }

  ngOnInit() {
  }

}
